export enum HeaderVariant {
  Home = 'home',
  Standard = 'standard',
  Reports = 'reports',
  Experiments = 'experiments',
}
